import "./index.scss";
import { LiveInspectorData } from "types/types";
import { useUpdateModal } from "utilities/ModalProvider";
import React from "react";
import recursiveRender from "utilities/recursiveRender";

interface CtaModalProps {
  children: React.ReactNode;
  className?: string;
  // TODO: ts modal json
  modal: any;
  dataTracking?: string;
  dataPosition?: string;
  liveInspector?: LiveInspectorData;
}

const CtaModal = ({
  children,
  className,
  modal,
  dataTracking,
  dataPosition,
  liveInspector,
}: CtaModalProps) => {
  const idModal = modal?.[0]?.id;
  const { openModal } = useUpdateModal();
  const onClick = () => {
    openModal?.(idModal);
  };

  return (
    <>
      <div
        onClick={onClick}
        onKeyDown={onClick}
        role="button"
        tabIndex={0}
        className={`${className} CtaModal`}
        data-tracking={dataTracking}
        data-position={dataPosition}
        {...liveInspector?.cta}
      >
        {children}
      </div>
      {recursiveRender({ cfComponent: modal })}
    </>
  );
};

export default CtaModal;
